function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "avatar-saki-2x-secret-b",
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "99.296%"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FCE6A9",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FBC549",
  offset: "57.569%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E2B500",
  offset: "100%"
})), /*#__PURE__*/React.createElement("rect", {
  id: "avatar-saki-2x-secret-a",
  width: 95,
  height: 95,
  rx: 22
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "avatar-saki-2x-secret-c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#avatar-saki-2x-secret-a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "url(#avatar-saki-2x-secret-b)",
  xlinkHref: "#avatar-saki-2x-secret-a"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  mask: "url(#avatar-saki-2x-secret-c)",
  d: "M71.333 7H40.336c-1.174 0-2.126.952-2.126 2.126v22.79c0 .526.426.952.952.952h17.85c.425 0 .77-.345.77-.77v-10.02c0-.59.48-1.068 1.07-1.068h8.355c.59 0 1.07.478 1.07 1.07v10.017c0 .426.345.77.77.77h10.2c1.305 0 2.363 1.06 2.363 2.364v4.533c0 1.306-1.058 2.363-2.362 2.363h-10.2c-.426 0-.772.345-.772.772V57.84c0 12.278-8.436 22.155-23.183 22.155H28.535c-.59 0-1.068-.48-1.068-1.07V72.42c0-.59.478-1.067 1.068-1.067h17.107c8.368 0 12.14-8.16 12.14-15.157v-13.3c0-.426-.345-.77-.77-.77H39.16c-.526 0-.952.426-.952.952v12.194c0 1.304-1.058 2.362-2.363 2.362h-5.013c-1.305 0-2.362-1.058-2.362-2.362V43.078c0-.526-.426-.953-.953-.953h-9.67c-1.304 0-2.362-1.057-2.362-2.363v-4.53c0-1.306 1.058-2.364 2.363-2.364h9.67c.526 0 .952-.426.952-.952V9.126C28.472 7.952 27.52 7 26.346 7h-1.678C14.91 7 7 14.91 7 24.67v46.66C7 81.09 14.91 89 24.668 89h46.664C81.09 89 89 81.09 89 71.332V24.668C89 14.91 81.09 7 71.333 7"
}));

var SvgSaki = function SvgSaki(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSaki, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/saki.67cc46f0.svg";
export { ForwardRef as ReactComponent };